import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantBrokerAccountService,
  VendorCompanyService,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetBrokerStatusOption = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const brokerStatusOption = useQuery(
    ['getBrokerStatusOption'],
    async () => {
      return await handleRequest(
        ParticipantBrokerAccountService.getApiCustomerApiAppParticipantBrokerAccountBrokerStatusList()
      );
    },
    {
      select: (data) => {
        if (data != null) {
          return data.map((info) => {
            return {
              label: info.displayName ?? '',
              value: info.id ?? '',
            };
          });
        }
      },
    }
  );

  return brokerStatusOption;
};

export default useGetBrokerStatusOption;
